import type { FormField } from '@lucid/lego';
import { getCustomerTypeOptions } from '../../../constants';

type OverviewFormDefaultValues = {
  customerType?: string;
  deliveryTimeline?: string;
  ofacCheckCompleted?: string;
  ofacCheckDate?: string;
  ofacStatus?: string;
};

/**
 * Creates form fields configuration for Order Overview form
 * Contains OFAC details, Customer Type and Delivery Timeline fields
 *
 * @param labels - i18n labels for form field labels and placeholders
 * @param defaultValues - Default values for all overview form fields
 * @param options - Additional options (e.g. disableDeliveryTimeline)
 * @returns Array of FormField configurations
 */
export const createOrderOverviewFormFields = (
  labels?: Record<string, string>,
  defaultValues?: OverviewFormDefaultValues,
  options?: { disableDeliveryTimeline?: boolean }
): FormField[] => [
  {
    id: 'ofacGroup',
    fieldType: 'group',
    title: labels?.ofacDetails || 'OFAC Details',
    children: [
      {
        id: 'ofacCheckCompleted',
        fieldType: 'content',
        label: labels?.ofacCheckCompleted || 'OFAC Check Completed',
        content: defaultValues?.ofacCheckCompleted || '-',
        variant: 'body',
        size: 'small',
        width: 'third',
      },
      {
        id: 'ofacCheckDate',
        fieldType: 'content',
        label: labels?.ofacCheckDate || 'OFAC Check Date',
        content: defaultValues?.ofacCheckDate || '-',
        variant: 'body',
        size: 'small',
        width: 'third',
      },
      {
        id: 'ofacStatus',
        fieldType: 'content',
        label: labels?.ofacStatus || 'OFAC Status',
        content: defaultValues?.ofacStatus || '-',
        variant: 'body',
        size: 'small',
        width: 'third',
      },
    ],
  },
  {
    id: 'customerType',
    fieldType: 'dropdown',
    name: 'customerType',
    apiKey: 'customerType',
    label: labels?.customerType ?? 'Customer Type',
    placeholder: labels?.customerTypePlaceholder ?? 'Select Customer Type',
    required: true,
    width: 'full',
    options: getCustomerTypeOptions(labels),
    defaultValue: defaultValues?.customerType,
    disabled: true,
  },
  {
    id: 'deliveryTimeline',
    fieldType: 'date_picker',
    name: 'deliveryTimeline',
    apiKey: 'deliveryTimeline',
    label: labels?.deliveryTimeline ?? 'Delivery Timeline',
    placeholder: labels?.deliveryTimelinePlaceholder ?? 'Select Date',
    required: false,
    minDate: 'today',
    width: 'full',
    defaultValue: defaultValues?.deliveryTimeline,
    disabled: options?.disableDeliveryTimeline,
  },
];
